<template>
  <section class="container">
    <div class="content">
      <div class="row w-100 mb-4">
        <div class="col-12 pl-3 px-0 mb-0 text-left">
          <BreadCrumbComponent :pageTitles="['Live Lecture']" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col-12 text-left">
          <!-- <div
            style="
              font-size: 20px;
              font-weight: 400;
              color: var(--el-app-primary);
              margin-bottom: 15px;
            "
          >
            <strong>Lectures</strong>
          </div> -->
          <div
            v-if="classUrl != ''"
            class="embed-responsive embed-responsive-16by9"
          >
            <iframe
              id="student_live"
              :src="classUrl"
              class="embed-responsive-item"
              allow="camera *; microphone *;"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import AvailableTestsAndExamsComponent from "../components/available-tests-and-exams-component.vue";
import BreadCrumbComponent from "../components/bread-crumb-component";
export default {
  components: {
    // AvailableTestsAndExamsComponent,
    BreadCrumbComponent,
  },
  data() {
    return {
      classUrl: "",
      // titles: [
      //   { prop: "title", label: "Title" },
      //   { prop: "username", label: "Username" },
      //   { prop: "gender", label: "Gender" },
      //   { prop: "access_level", label: "Access Level" },
      //   { prop: "last_login", label: "Last Login" },
      // ],
    };
  },

  mounted() {
    // this.classUrl = this.$route.params.classUrl;
    //TODO: REVIST THIS IMPLEMENTATION
    //If there's nothing in the route params, check local storage
    if (!this.$route.params.classUrl) {
      let classUrlFromStorage = (localStorage.getItem("isPersistent") ? localStorage : sessionStorage).getItem("StudentsClassUrl");
      this.classUrl = classUrlFromStorage;
    }

    //Else if we have a route param, check if we need or may not to update Local Storage
    else {
      let classUrlFromStorage = (localStorage.getItem("isPersistent") ? localStorage : sessionStorage).getItem("StudentsClassUrl");
      if (classUrlFromStorage != this.$route.params.classUrl) {
        (localStorage.getItem("isPersistent") ? localStorage : sessionStorage).setItem("classUrl", this.$route.params.classUrl);
      }
      this.classUrl = this.$route.params.classUrl;
    }
  },
};
</script>

<style scoped>
.content {
  margin-top: 45px !important;
}
.ui-margin {
  margin-left: 42px !important;
  margin-right: 42px !important;
}

@media (max-width: 768px) {
  .content {
    margin-top: 15px !important;
  }
}
</style>


<style>
th > .cell {
  color: rgba(0, 0, 0, 0.836) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}
el-table th > .cell {
  color: black !important;
  font-weight: 500;
}
.el-table .cell {
  font-size: 0.9em;
  line-height: 23px;
  font-weight: 300;
}
</style>